import {
  Component,
  ElementRef,
  HostListener,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import EditorJS from '@editorjs/editorjs';
const Header = require('@editorjs/header');
import { BlogServiceService } from '../blog-service.service';
import ImageTool from '@editorjs/image';
import List from '@editorjs/list';
import Table from '@editorjs/table';
import * as AWS from 'aws-sdk';
const Delimiter = require('@editorjs/delimiter');
const InlineCode = require('@editorjs/inline-code');
const ColorPlugin = require('editorjs-text-color-plugin');
import { OutputData } from '@editorjs/editorjs';
import { environment } from 'src/environments/environment';
import { MetaTagsPopupComponent } from '../meta-tags-popup/meta-tags-popup.component';
import { Blog, BlogStatus, BlogType, Blog_Cachekeys } from '../blog';
import moment from 'moment';
import { DeleteBlogComponent } from '../delete-blog/delete-blog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationFilterComponent } from '../confirmation-filter/confirmation-filter.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { PricingDetailsComponent } from 'src/app/shared-module-files/components/pricing-details/pricing-details.component';
import { MatDialogRef } from '@angular/material/dialog';
import { BlogPluginComponent } from '../blog-plugin/blog-plugin.component';
import { EventEmmiterService } from 'src/app/services/event-emmiter.service';
import { AiWriterWrapperComponent } from 'src/app/master-config-components/micro-apps/ai-writer-wrapper/ai-writer-wrapper.component';
import { WebsiteMarketingServiceService } from 'src/app/master-config-components/micro-apps/website-marketing/services/website-marketing-service.service';

@Component({
  selector: 'app-create-blogs',
  templateUrl: './create-blogs.component.html',
  styleUrls: ['./create-blogs.component.scss', './mq-create-blogs.component.scss']
})
export class CreateBlogsComponent {

  action: String = "";
  homeDirection: boolean = false;
  constructor(
    private blogService: BlogServiceService,
    private router: Router,
    private route: ActivatedRoute,
    private _snackbar : MatSnackBar,
    private _bottomSheet:MatBottomSheet,
    private eventEmitter: EventEmmiterService,
    private websiteMarketing: WebsiteMarketingServiceService,
  ) {
    this.route.queryParams.subscribe(queryParams => {
      this.action = queryParams['action'];
      if (this.action != null) {
        if (this.action === 'addBlogHome') {
          this.homeDirection = true;
        }
      }
    })
    this.getScreenSize();
  }

  screenWidth: any;
  @HostListener("window: resize")
  getScreenSize() {
    this.screenWidth = window.innerWidth;
  }
  words: any;
  readTime: any = 0;
  wordCount: any = 0;
  characterCount:any = 0;
  paragraphCount: any = 0;
  sentenceCount: any = 0;
  ngOnInit(): void {
    this.blog = this.blogService.getBlogData();

    if (!this.blog.businessId && this.blog.blogType === BlogType.BUSINESS) {
      let businessDetails: any = window.localStorage.getItem('bDetails');
      businessDetails = businessDetails ? JSON.parse(businessDetails) : null;

      if (businessDetails) {
        this.blog.businessId = businessDetails.id;
      }
    }

    this.blog.blogType = BlogType.BUSINESS;
    // this.intialzedEditor();
  }

  ngAfterViewInit(): void {
    this.showApiData();
  }

  screenLoading: boolean = false;
  isSavingDraft: boolean = false;
  isPublishing: boolean = false;

  @ViewChild('editor', { read: ElementRef, static: false }) editorElement?: ElementRef;

  previousData: OutputData | undefined;
  @ViewChild("text") text: ElementRef | undefined;
  editor: EditorJS | undefined;

  private intialzedEditor(): void {
    if (this.editorElement?.nativeElement) {
      this.editorElement.nativeElement.innerHTML = '';
    }
    this.editor = new EditorJS({
      // minHeight:200,
      holder: this.editorElement?.nativeElement,
      tools: {
        delimiter: Delimiter,
        header: {
          class: Header,
          shortcut: 'CMD+SHIFT+H',
          inlineToolbar: ['link', 'bold', 'italic'],
        },

        Color: {
          class: ColorPlugin,
          config: {
            colorCollections: [
              '#EC008C',
              '#AB47BC',
              '#7E57C2',
              '#5C6BC0',
              '#1E88E5',
              '#00ACC1',
              '#26A69A',
              '#4CAF50',
              '#8BC34A',
              '#D4E157',
              '#FFEE58',
              '#FFCA28',
              '#FFA726',
              '#FF7043',
              '#8D6E63',
              '#B0BEC5',
            ],
            defaultColor: '#FF1300',
            type: 'text',
            customPicker: true,
          },
        },
        Marker: {
          class: ColorPlugin, // if load from CDN, please try: window.ColorPlugin
          config: {
            defaultColor: '#FFBF00',
            type: 'marker',
          },
        },
        // Marker :{
        //   class : Marker,
        //   shortcut : 'CMD+SHIFT+M'
        // },
        list: {
          class: List,
          inlineToolbar: ['link', 'bold', 'italic'],
        },
        inlineCode: {
          class: InlineCode,
          shortcut: 'CMD+SHIFT+M',
        },
        image: {
          class: ImageTool,
          config: {
            uploader: {
              uploadByFile(file: any) {
                const imageEnvCognito =
                  environment.componentImageUploading.CredentialsProvider
                    .CognitoIdentity.Default;
                const imageEnvUtility =
                  environment.componentImageUploading.S3TransferUtility.Default;

                const AWSService = AWS;
                const region = imageEnvUtility.Region;
                const bucketName = imageEnvUtility.Bucket;
                const IdentityPoolId = imageEnvCognito.PoolId;
                // ? Configures the AWS service and initial authorization
                AWSService.config.update({
                  region: region,
                  credentials: new AWSService.CognitoIdentityCredentials({
                    IdentityPoolId: IdentityPoolId,
                  }),
                });
                const s3 = new AWSService.S3({
                  apiVersion: '2012-07-10',
                  params: {
                    Bucket: bucketName,
                  },
                });

                let imgPromise = new Promise((res, rej) => {
                  if (file) {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                      s3.upload(
                        {
                          Key:
                            'images/' +
                            Math.floor(100000 + Math.random() * 900000) +
                            'c' +
                            new Date().getTime() +
                            file.name,
                          Bucket: bucketName,
                          Body: file,
                          ACL: 'public-read',
                        },
                        function (err: any, data: any) {
                          if (err) {
                            rej(err);
                          } else {
                            res(data);
                          }
                        }
                      );
                    };
                  }
                });

                return imgPromise
                  .then((data: any) => {
                    return {
                      success: 1,
                      file: {
                        url: data.Location,
                        height: '500px',
                      },
                    };
                  })
                  .catch((err) => {
                    return err;
                  });
              },
            },
          },
        },
        table: {
          class: Table,
          inlineToolbar: true,
          config: {
            rows: 2,
            cols: 3,
          },
        },
      },
      data: this.previousData,
      defaultBlock: 'header',
      autofocus: true,
      placeholder: 'Enter content',
      onReady: () => {
        this.attachToolbarToExistingImages();
      },

      onChange: () => {
        this.attachToolbarToNewImages();
      }
    });
    // this.editor?.blocks?.clear();
  }

  private attachToolbarToExistingImages() {
    if (!this.editorElement?.nativeElement) return;
    const blocks = this.editorElement.nativeElement.querySelectorAll('.ce-block img');
    blocks.forEach((img: HTMLImageElement) => this.attachToolbar(img));
  }

  private attachToolbarToNewImages() {
    if (!this.editorElement?.nativeElement) return;
    const blocks = this.editorElement.nativeElement.querySelectorAll('.ce-block img');

    blocks.forEach((img: HTMLImageElement) => {
      const wrapper = img.closest('.ce-block')?.querySelector('.image-toolbar');

      if (!wrapper) {
        this.attachToolbar(img);
      }
    });
  }

  goToAiWriter(): void {
    this.eventEmitter.aiWriterCalled.next({ data: { toOpen: 'blog', type: 'create-blog' } })
    setTimeout(() => {
      let height = "100vh";
      let width = "100vw";
      let dialog = this.websiteMarketing.openPost(
        AiWriterWrapperComponent,
        height,
        width,
        '100vw',
        {},
      );
      dialog.afterClosed().subscribe((data: any) => {
      });
    }, 1200);
  }

  private attachToolbar(img: HTMLImageElement) {
    const block = img.closest('.ce-block') as HTMLElement;
    if (!block) return;

    const wrapper = block.querySelector('.ce-block__content') as HTMLElement;
    if (!wrapper) return;

    wrapper.style.position = 'relative';

    const toolbar = document.createElement('div');
    toolbar.classList.add('image-toolbar');

    // DELETE button
    const del = document.createElement('button');
    del.textContent = 'Delete';
    del.onclick = () => {
      if (!this.editorElement?.nativeElement) return;
      const index = Array.from(this.editorElement.nativeElement.querySelectorAll('.ce-block')).indexOf(block);
      if (index !== -1) {
        this.editor?.blocks.delete(index);
      }
    };

    toolbar.appendChild(del);
    wrapper.appendChild(toolbar);
  }

  publishBlog() {
    this.isPublishing = true;
    this.screenLoading = true;
    this.editor?.save().then((data: any) => {
      if (data.blocks && !data.blocks.length) {
        this.blogService.openSnack(
          'Please write something to create Post',
          'Close'
        );
        this.screenLoading = false;
        this.isPublishing = false;
        return;
      } else if (this.blog.postTitle === '' || this.blog.postSummary === '' || this.blog.articleSlug === '') {
        this._snackbar.open(
          `Please fill mandatory fields`,
          'Ok',
          {
            duration: 1500
          }
        );
        this.screenLoading = false;
        this.isPublishing = false;
  
        this.blogService.setBlogData(this.blog);
  
          let blogModel = this.blogService.filterDialog(
            MetaTagsPopupComponent,
            'meta-tags-dialog-container',
            '100vh',
            '25%',
            'relative',
            {
              data: {
                typeRequest: "addtags"
              }
            },
          );
          blogModel.afterClosed().subscribe((data: any) => {
            if (!data) return;
  
            this.blog = this.blogService.getBlogData();
          });
        return;
      }
  
      this.blog.blocks = data.blocks;
  
      this.getBlocksTextLen(data.blocks);
      this.blog.createdBy = window.localStorage.getItem('fname') || '';
      this.blog.readTime = Math.ceil(this.wordCount / 225).toString();
      this.blog.wordCount = this.wordCount;
      this.blog.blogStatus = BlogStatus.PUBLISH;
  
      this.blog.blogScheduledDate = moment(new Date()).format('YYYY-MM-DD');
  
      const date = new Date();
      this.blog.blogScheduleTime = `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}.000`;
      this.blog.updatedTimeStamp = moment(new Date()).format();
  
      if (this.blog.id) {
        this.updateBlog();
      } else {
        this.blog.createdTimeStamp = moment(new Date()).format();
        this.createBlog();
      }
    })
    .catch((err) => {
      this.screenLoading = false;
      this.isPublishing = false;
    });
  }

  couldBeCounted(block: any) {
    return block && block.data && 'text' in block.data && typeof block.data.text === 'string';
  }

  sumWords: any;
  getBlocksTextLen(blocks: any[]) {
    if (!Array.isArray(blocks)) return 0;
    return blocks
      .filter((b) => this.couldBeCounted(b))
      .reduce((sum, block) => {
        let data = block.data.text || '';
        data = data.replaceAll("<br>", "");
        data = data.replaceAll("<b>", "");
        data = data.replaceAll("</b>", "");

        this.sumWords = (this.sumWords || 0) + data.split(" ").length;
        return sum + data.split(" ").length;
      }, 0)
  }

  jsonData: any = '';
  showApiData() {
    if (this.blog.id) {
      let blogData = this.blogService.getBlogData() || {};
      let rawBlocks = Array.isArray(blogData.blocks) ? blogData.blocks : [];
      let cleanBlocks = rawBlocks.filter((b: any) => b && typeof b === 'object' && b.type);

      let dataSending: any = {
        time: blogData.time || 0,
        version: blogData.version || '',
        blocks: cleanBlocks,
      };
      this.previousData = dataSending;
      this.getBlogDetailsWordsCount(this.previousData);
    } else {
      this.previousData = undefined;
    }
    this.intialzedEditor();
  }

  back() {
    window.localStorage.removeItem(Blog_Cachekeys.BLOG_SETTINGS);
    if (this.homeDirection) {
      this.router.navigate(['/admin/home']);
    }
    else {
      this.router.navigate(['/admin/website/blogs/listing']);
    }
  }

  saveToDraft() {
    this.isSavingDraft = true;
    this.screenLoading = true;
    this.editor
      ?.save()
      .then((data: any) => {
        if (data.blocks && !data.blocks.length) {
          this.blogService.openSnack(
            'Please write something to create Post',
            'Close'
          );
          this.screenLoading = false;
          this.isSavingDraft = false;
          return;
        }
        else if(this.blog.postTitle === '' || this.blog.postSummary === ''){
          this._snackbar.open(
            `Please fill mandatory fields`,
            'Ok',
            {
              duration:1500
            }
          );
          this.screenLoading = false;
          this.isSavingDraft = false;

          this.blogService.setBlogData(this.blog);

            let blogModel = this.blogService.filterDialog(
              MetaTagsPopupComponent,
              'meta-tags-dialog-container',
              '100vh',
              '25%',
              'relative',
              {
                data: {
                  typeRequest: "addtags"
                }
              },
            );
            blogModel.afterClosed().subscribe((data: any) => {
              if (!data) return;
        
              this.blog = this.blogService.getBlogData();
            });
          return;
        }

        this.blog.blocks = data.blocks;

        this.getBlocksTextLen(data.blocks);

        this.blog.createdBy = window.localStorage.getItem('fname') || '',
        this.blog.readTime = Math.ceil(this.wordCount / 225).toString();
        this.blog.wordCount = this.wordCount;
        this.blog.blogStatus = BlogStatus.SAVE;
        this.blog.updatedTimeStamp = moment(new Date()).format();

        if (this.blog.id) {
          this.updateBlog();
        } else {
          this.blog.createdTimeStamp = moment(new Date()).format();
          this.createBlog();
        }
      })
      .catch((err) => {
        this.screenLoading = false;
        this.isSavingDraft = false;
      });
  }

  private createBlog() {
    const blogData = JSON.parse(JSON.stringify(this.blog));
    delete blogData.id;

    this.blogService.createBlog(blogData).subscribe({
      next: (res: any) => {
        this.showSuccessMessage();

        this.screenLoading = false;
        this.isSavingDraft = false;
        this.isPublishing = false;
        this.back();
      },
      error: (err: any) => {
        if(err.error.errorCode === 2000){
          this.blogService.openSocialBrand(PricingDetailsComponent, '100vh', '100%', {})
        }
        this.sumWords = 0;
        this.blog.readTime = '0';
        this.screenLoading = false;
        this.isSavingDraft = false;
        this.isPublishing = false;

        this.blogService.openSnack(
          'Something went wrong, please try again later',
          'Ok'
        );
      },
    });
  }

  private updateBlog() {
    this.blogService.updateBlog(this.blog).subscribe({
      next: (res: any) => {
        this.showSuccessMessage();
        this.screenLoading = false;
        this.isSavingDraft = false;
        this.isPublishing = false;
        this.back();
      },
      error: (err: any) => {
        this.sumWords = 0;
        this.blog.readTime = '0';
        this.screenLoading = false;
        this.isSavingDraft = false;
        this.isPublishing = false;

        this.blogService.openSnack(
          'Something went wrong, please try again later',
          'Ok'
        );
      },
    });
  }

  showSuccessMessage() {
    if (this.blog.blogStatus === BlogStatus.SAVE) {
      this.blogService.openSnack(
        'Your post is successfully saved and you can edit later.',
        'Ok'
      );
    } else {
      if(this.blog.blogStatus === BlogStatus.PUBLISH)
      this.blogService.openSnack(
        'Your post will be published. Thankyou',
        'Ok'
      );
    }
  }

  deleteBlog() {
    if(this.screenWidth > 475){
    this.blogService.filterDialog(
      DeleteBlogComponent,
      'filter-dialog-container',
      'auto',
      '350px',
      'relative',
      { blogId: this.blog.id },
    );
    }
    if(this.screenWidth < 475){
      this.blogService.openBottomSheet(
        DeleteBlogComponent,
        'filter-dialog-container',
        { blogId: this.blog.id },
      );
    }
  }
  confirmationFilter() {
    if (this.screenWidth > 475){
    this.blogService.filterDialog(
      ConfirmationFilterComponent,
      'filter-dialog-container',
      'auto',
      'auto',
      'relative',
      { blogId: this.blog.id },
    );
    }

    if (this.screenWidth < 475){
      this.blogService.openBottomSheet(
        ConfirmationFilterComponent,
        'filter-dialog-container',
        { blogId: this.blog.id },
      );
    }
  }

  countwords() {
    
  }

  // words: any;
  // wordCount: number = 0;
  // characterCount: number = 0;
  // paragraphCount: number = 0;
  // sentenceCount: number = 0;
  async wordCounter(event) {

    const savedData = await this.editor?.save();
    const content = savedData?.blocks.map(block => block.data.text).join(" ");

    this.characterCount = content ? content.length : 0;
    this.wordCount = content ? content.split(/\s+/).filter(word => word !== '').length : 0;
    this.paragraphCount = content ? content.split(/\n\s+\n/).filter(paragraph => paragraph.trim() !== '').length : 0;
    this.sentenceCount = content ? content.split(/[.!?]/).filter(sentence => sentence.trim() !== '').length : 0;

    //for reading time
    const wordsPerMinute = 225;
    const wordCount = content ? content.split(/\s+/).filter(word => word !== '').length : 0;
    const readTimeInminutes = wordCount / wordsPerMinute;
    const minutes = Math.round(readTimeInminutes);
    const minutesText = minutes === 1 ? "minute" : "minutes";
    const seconds = Math.round(readTimeInminutes * 60) % 60;
    const secondsText = seconds === 0 ? "" : seconds + " seconds";

    this.readTime = minutes + " " + minutesText + " " + secondsText;
  }

  async getBlogDetailsWordsCount(savedData){
    const content =  await savedData?.blocks.map(block => block.data.text).join(" ");

    this.characterCount = content ? content.length : 0;
    this.wordCount = content ? content.split(/\s+/).filter(word => word !== '').length : 0;
    this.paragraphCount = content ? content.split(/\n\s+\n/).filter(paragraph => paragraph.trim() !== '').length : 0;
    this.sentenceCount = content ? content.split(/[.!?]/).filter(sentence => sentence.trim() !== '').length : 0;

    //for reading time
    const wordsPerMinute = 200;
    const wordCount = content ? content.split(/\s+/).filter(word => word !== '').length : 0;
    const readTimeInminutes = wordCount / wordsPerMinute;
    const minutes = Math.round(readTimeInminutes);
    const minutesText = minutes === 1 ? "minute" : "minutes";
    const seconds = Math.round(readTimeInminutes * 60) % 60;
    const secondsText = seconds === 0 ? "" : seconds + " seconds";

    this.readTime = minutes + " " + minutesText + " " + secondsText;
  }

  blog: Blog = new Blog();

  openBlogSettingsDialog(ev: MouseEvent) {
    ev.stopPropagation();

    this.blogService.setBlogData(this.blog);

    let blogModel = this.blogService.filterDialog(
      MetaTagsPopupComponent,
      'meta-tags-dialog-container',
      '100vh',
      '25%',
      'relative',
      {
        data: {
          typeRequest: "addtags"
        }
      },
      '',
      '',
      false
    );
    blogModel.afterClosed().subscribe((data: any) => {
      if (!data) return;

      this.blog = this.blogService.getBlogData();
    });
  }
}
